import {
    SAVE_ALL_PO, SAVE_PART_DETAILS, SAVE_PO_DROPDOWN_LISTS, SAVE_SUPPLIER_ITEM_MASTER
  } from "Constants/actionConstants";

  const initialState = {
    ordersData: [],
    totalCount: '',
    poStatusCount: {},
    poDropdownLists: {},
    partDetails: [],
    supplierItemMaster: []
  };
  
  const PODetails = (state = initialState, { type, payload }) => {
    switch (type) {
      case SAVE_ALL_PO: {
        return {
          ...state,
          ordersData: payload && payload.data || [],
          totalCount: payload && payload.totalCount || '',
          poStatusCount: payload && payload.poStatusCount || {}
        };
      }
      case SAVE_PO_DROPDOWN_LISTS: {
        return {
            ...state,
            poDropdownLists: payload || {}
          };
      }
      case SAVE_PART_DETAILS: {
        return {
          ...state,
          partDetails: payload || []
        }
      }
      case SAVE_SUPPLIER_ITEM_MASTER: {
        return {
          ...state,
          supplierItemMaster: payload || []
        }
      }
      default:
        return state;
    }
  };
  
  export default PODetails;
  